import {
  Box,
  Button,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";
import { caseManagementUrl } from "../../../../config";
import Header from "../../../../components/Header";
import CaseCategory from ".";

const base_url = caseManagementUrl.uri;

const CaseStatusForm = (props) => {
  const { onAction } = props;
  const initialValues = {
    status: props.data?.status || "",
  };

  const validationSchema = yup.object().shape({
    status: yup.string().required("Status is required"),
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userIdFromSession = parseInt(decodedToken.Id);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { status } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id, // must not be null
            status: values.status,
          }
        : {
            status: values.status,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCaseStatuses" : "createCaseStatuses",
        mutationData,
        "newCaseStatus",
        base_url
      );

      if (response && Object.values(response)[0] != null) {
        props.onClose?.();
        if (onAction) {
          onAction();
        } else {
          props.refetchData?.();
        }

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Case status ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Server did not return expected data. Please check API response.",
        });
      }
    } catch (error) {
      console.error("Case status creation/update error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Case Status" : "Create Case Status"}
        subtitle={props.isEditing ? "Edit an existing case status" : "Create a new case status"}
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              {/* Event Type */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Status"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.status}
                name="status"
                error={touched.status && !!errors.status}
                helperText={touched.status && errors.status}
                sx={{ gridColumn: "span 4" }}
              />

              {/* Description */}
              {/* <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}  
                sx={{ gridColumn: "span 4" }}
              /> */}
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CaseStatusForm;